import {
  HttpHeaders,
  provideHttpClient,
  withFetch,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  inject,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideApollo, APOLLO_NAMED_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';

const SHOPIFY_VERSION = '2025-01';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const sharedCache = new InMemoryCache();

      // Default Apollo client (optional)
      return {
        cache: sharedCache,
        ssrMode: typeof window === 'undefined',
        link: httpLink.create({
          uri: 'https://graph.smattmyers.com/v1/graphql',
        }),
      };
    }),
    {
      provide: APOLLO_NAMED_OPTIONS,
      useFactory: () => {
        const httpLink = inject(HttpLink);
        const sharedCache = new InMemoryCache();
        return {
          RMR: {
            cache: sharedCache,
            ssrMode: typeof window === 'undefined',
            link: httpLink.create({
              uri: `https://rockymountainradar.myshopify.com/api/${SHOPIFY_VERSION}/graphql.json`,
              headers: new HttpHeaders({
                'X-Shopify-Storefront-Access-Token':
                  'a0ab8680fb02dcf874912a0bde788808',
              }),
            }),
          },
          BPUS: {
            cache: sharedCache,
            ssrMode: typeof window === 'undefined',
            link: httpLink.create({
              uri: `https://born-primitive.myshopify.com/api/${SHOPIFY_VERSION}/graphql.json`,
              // headers: new HttpHeaders({ 'X-Shopify-Storefront-Access-Token': 'e6a1027fccec980c60a29c8f2ccdb47b' })
              headers: new HttpHeaders({
                'X-Shopify-Storefront-Access-Token':
                  'd8b3352fff81f0717dde98f94dfd546e',
              }),
            }),
          },
          infrastructure: {
            cache: sharedCache,
            ssrMode: typeof window === 'undefined',
            link: httpLink.create({
              uri: 'https://graph.smattmyers.com/v1/graphql',
            }),
          },
        };
      },
    },
  ],
};
